import React, { lazy, Suspense } from 'react'
import { Row, useContainerWidth } from '@fs/zion-ui'
import Text from './Text'

const ChurchLogo = lazy(() => import('./ChurchLogo'))

export default function Legal({ nonReligiousMode, external }) {
  const atWidth = useContainerWidth()
  const isMobile = atWidth({ default: true, xs: false })

  return (
    <Row gutters="xl" guttersY="sm" alignX={isMobile ? 'center' : 'start'} wrap={isMobile ? 'reverse' : false}>
      <Text growX alignY="middle" nonReligiousMode={nonReligiousMode} external={external} />
      {!nonReligiousMode && (
        <Suspense fallback="" noShrinkX>
          <ChurchLogo />
        </Suspense>
      )}
    </Row>
  )
}
